import type React from 'react'

type Props = {
  className?: string
  width?: number
  height?: number
}

export const PresetSlateGreen: React.FC<Props> = ({
  className,
  width = 96,
  height = 64,
}) => {
  return (
    <svg
      className={className}
      width={width}
      height={height}
      viewBox="0 0 96 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_61055_83872)">
        <path
          d="M0 6C0 2.68629 2.68629 0 6 0H90C93.3137 0 96 2.68629 96 6V58C96 61.3137 93.3137 64 90 64H6C2.68629 64 0 61.3137 0 58V6Z"
          fill="#557177"
        />
        <path
          d="M30 42.8C30 41.1198 30 40.2798 30.327 39.638C30.6146 39.0735 31.0735 38.6146 31.638 38.327C32.2798 38 33.1198 38 34.8 38H81.2C82.8802 38 83.7202 38 84.362 38.327C84.9265 38.6146 85.3854 39.0735 85.673 39.638C86 40.2798 86 41.1198 86 42.8V55.7C86 57.3802 86 58.2202 85.673 58.862C85.3854 59.4265 84.9265 59.8854 84.362 60.173C83.7202 60.5 82.8802 60.5 81.2 60.5H34.8C33.1198 60.5 32.2798 60.5 31.638 60.173C31.0735 59.8854 30.6146 59.4265 30.327 58.862C30 58.2202 30 57.3802 30 55.7V42.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68 44.75C68 45.1642 67.6642 45.5 67.25 45.5H36.75C36.3358 45.5 36 45.1642 36 44.75C36 44.3358 36.3358 44 36.75 44H67.25C67.6642 44 68 44.3358 68 44.75Z"
          fill="#768BA7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80 49.25C80 49.6642 79.6642 50 79.25 50H36.75C36.3358 50 36 49.6642 36 49.25C36 48.8358 36.3358 48.5 36.75 48.5H79.25C79.6642 48.5 80 48.8358 80 49.25Z"
          fill="#768BA7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M56 53.75C56 54.1642 55.6642 54.5 55.25 54.5H36.75C36.3358 54.5 36 54.1642 36 53.75C36 53.3358 36.3358 53 36.75 53H55.25C55.6642 53 56 53.3358 56 53.75Z"
          fill="#768BA7"
        />
        <path
          d="M30 20.8C30 19.1198 30 18.2798 30.327 17.638C30.6146 17.0735 31.0735 16.6146 31.638 16.327C32.2798 16 33.1198 16 34.8 16H81.2C82.8802 16 83.7202 16 84.362 16.327C84.9265 16.6146 85.3854 17.0735 85.673 17.638C86 18.2798 86 19.1198 86 20.8V29.2C86 30.8802 86 31.7202 85.673 32.362C85.3854 32.9265 84.9265 33.3854 84.362 33.673C83.7202 34 82.8802 34 81.2 34H34.8C33.1198 34 32.2798 34 31.638 33.673C31.0735 33.3854 30.6146 32.9265 30.327 32.362C30 31.7202 30 30.8802 30 29.2V20.8Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M80 22.75C80 23.1642 79.6642 23.5 79.25 23.5H36.75C36.3358 23.5 36 23.1642 36 22.75C36 22.3358 36.3358 22 36.75 22H79.25C79.6642 22 80 22.3358 80 22.75Z"
          fill="#768BA7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M68 27.25C68 27.6642 67.6642 28 67.25 28H36.75C36.3358 28 36 27.6642 36 27.25C36 26.8358 36.3358 26.5 36.75 26.5H67.25C67.6642 26.5 68 26.8358 68 27.25Z"
          fill="#768BA7"
        />
        <path
          d="M13 9.5C13 9.08579 13.3358 8.75 13.75 8.75H20.75C21.1642 8.75 21.5 9.08579 21.5 9.5C21.5 9.91421 21.1642 10.25 20.75 10.25H13.75C13.3358 10.25 13 9.91421 13 9.5Z"
          fill="#E8EFF7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 22.75C20 23.1642 19.6642 23.5 19.25 23.5H8.75C8.33579 23.5 8 23.1642 8 22.75C8 22.3358 8.33579 22 8.75 22H19.25C19.6642 22 20 22.3358 20 22.75Z"
          fill="#E8EFF7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 27.25C16 27.6642 15.6642 28 15.25 28H8.75C8.33579 28 8 27.6642 8 27.25C8 26.8358 8.33579 26.5 8.75 26.5H15.25C15.6642 26.5 16 26.8358 16 27.25Z"
          fill="#E8EFF7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M20 31.75C20 32.1642 19.6642 32.5 19.25 32.5H8.75C8.33579 32.5 8 32.1642 8 31.75C8 31.3358 8.33579 31 8.75 31H19.25C19.6642 31 20 31.3358 20 31.75Z"
          fill="#E8EFF7"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M16 36.25C16 36.6642 15.6642 37 15.25 37H8.75C8.33579 37 8 36.6642 8 36.25C8 35.8358 8.33579 35.5 8.75 35.5H15.25C15.6642 35.5 16 35.8358 16 36.25Z"
          fill="#E8EFF7"
        />
        <circle cx="9.5" cy="9.5" r="1.5" fill="#E8EFF7" />
      </g>
      <defs>
        <clipPath id="clip0_61055_83872">
          <path
            d="M0 6C0 2.68629 2.68629 0 6 0H90C93.3137 0 96 2.68629 96 6V58C96 61.3137 93.3137 64 90 64H6C2.68629 64 0 61.3137 0 58V6Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  )
}
